<!--
   Created by qing on 2020/2/27 3:47 下午
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__image" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <ul class="image__list">
          <li
            v-for="(img, idx) in currentRow[current.dataId]"
            class="image__list-item"
            :key="img.id">
            <template>
              <van-image
                v-if="img.imgUrl"
                width="60"
                height="60"
                @click="previewImage(idx)"
                :src="img.imgUrl"
                radius="6"
                fit="cover">
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20">
                  </van-loading>
                </template>
              </van-image>
              <div v-else-if="img.status === 'uploading'" class="wait-upload-container">
                <van-loading
                  type="spinner"
                  size="20">
                </van-loading>
              </div>
              <van-image
                v-else-if="img.status === 'fail'"
                width="60"
                height="60"
                src=""
                radius="6">
                <template v-slot:error>上传失败</template>
              </van-image>
            </template>
            <div
              v-if="!isReadOnly && !isRead && (img.imgUrl || img.status === 'fail')"
              @click="removeImage(idx)"
              class="image__list-remove">
              <van-icon
                size="14"
                name="cross">
              </van-icon>
            </div>
          </li>
          <li
            v-if="!isReadOnly && !isRead"
            @click="selectFile"
            class="image__list-add">
            <van-icon
              v-show="!showLoading"
              size="30"
              name="plus">
            </van-icon>
            <van-loading
              v-show="showLoading"
              type="spinner"
              size="20">
            </van-loading>
          </li>
        </ul>

        <div
          v-if="isRead && (!currentRow[current.dataId] || !currentRow[current.dataId].length)"
          class="el-input el-input--medium">
          暂无内容
        </div>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__image-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="isRead && (!currentRow[current.dataId] || !currentRow[current.dataId].length)"
            class="el-input el-input--medium">
            暂无内容
          </div>
          <ul v-else class="image__list">
            <li
              v-for="(img, idx) in currentRow[current.dataId]"
              class="image__list-item"
              :key="img.id">
              <template>
                <van-image
                  v-if="img.imgUrl"
                  width="60"
                  height="60"
                  @click="previewImage(idx)"
                  :src="img.imgUrl"
                  radius="6"
                  fit="cover">
                  <template v-slot:loading>
                    <van-loading
                      type="spinner"
                      size="20">
                    </van-loading>
                  </template>
                </van-image>
                <div v-else-if="img.status === 'uploading'" class="wait-upload-container">
                  <van-loading
                    type="spinner"
                    size="20">
                  </van-loading>
                </div>
                <van-image
                  v-else-if="img.status === 'fail'"
                  width="60"
                  height="60"
                  src=""
                  radius="6">
                  <template v-slot:error>上传失败</template>
                </van-image>
              </template>
              <div
                v-if="!isReadOnly && !isRead && (img.imgUrl || img.status === 'fail')"
                @click="removeImage(idx)"
                class="image__list-remove">
                <van-icon
                  size="14"
                  name="cross">
                </van-icon>
              </div>
            </li>
            <li
              v-if="!isReadOnly && !isRead"
              @click="selectFile"
              class="image__list-add">
              <van-icon
                v-show="!showLoading"
                size="30"
                name="plus">
              </van-icon>
              <van-loading
                v-show="showLoading"
                type="spinner"
                size="20">
              </van-loading>
            </li>
          </ul>
        </template>
      </van-field>
    </div>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import {current} from './mixin'
  import {ImagePreview} from 'vant'
  import {uuid} from "../../utils"
  import {arrayRemove, base64ToFile, showSize} from "../../../../assets/js/Untis"

  export default {
    mixins: [current],
    data() {
      return {
        dialogVisible: false,
        dialogImageUrl: '',
        showLoading: false,
        loadingPercentage: 0,
        fileInput: null,
        localIds: [],
        timer: null
      }
    },
    created() {
      this.fileInput = document.createElement('input')
      this.fileInput.setAttribute('type', 'file')
      this.fileInput.setAttribute('accept', 'image/*')
      this.fileInput.setAttribute('multiple', true)

      if (this.current.photoOnly) {
        this.fileInput.setAttribute('capture', 'camera')
      }
      this.fileInput.onchange = this.fileChange
      // 接收消息分发
      document.addEventListener('UPLOAD_IMAGE_SUCCESS', this.receiveUploadImageNewMessage)
    },
    destroyed() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      document.removeEventListener('UPLOAD_IMAGE_SUCCESS', this.receiveUploadImageNewMessage)
    },
    methods: {

      // file input change 事件触发
      fileChange(e) {
        const files = Array.from(e.target.files)
          .filter(file => {
            if (file.type.indexOf('image/') === 0) {
              const fileInfo = this.current.createFileInfo(file)
              return !(this.current.sizeLimit && fileInfo.imgSize > this.current.limitSize)
            }
          })
        const filesInfo = files.map(file => this.current.createFileInfo(file))
        if (files.length) {
          this.showLoading = true
          this.current.root.uploadFileMap[filesInfo[0].id] = true
          this.$RyFs.upload(files)
            .then(urlList => {
              urlList.map((url, idx) => {
                const image = new Image()
                image.src = url
                filesInfo[idx].imgUrl = url
              })
              this.currentRow[this.current.dataId].push(...filesInfo)
              this.controlChange()
              this.showLoading = false
              if (this.currentRow[this.current.dataId].length === 1) {
                this.submitData()
              }
              this.settingWaterMark(urlList[0])
            })
            .catch(err => {
              console.error(err)
              this.showLoading = false
            })
            .finally(() => {
              this.current.root.uploadFileMap[filesInfo[0].id] = false
              this.fileInput.value = ''
            })
        }
      },

      // 添加图片
      async selectFile() {
        if (this.isReadOnly || this.showLoading) return
        // this.fileInput.click()
        if (this.current.uploadOneOnly === 1 && this.currentRow[this.current.dataId].length > 0) {
          this.$toast.fail('最多只可选择一张图片')
          return
        }

        // 判读是否是在小程序环境
        //  let isMiniprogram = false
        // if (window.isWexin) {
        //   await this.$wx.miniProgram.getEnv(function (res) {
        //     isMiniprogram = res.miniprogram
        //   });
        // }

        // 判读是否是在微信环境
        if (window.isWexin || window.isWxWork) {
          // 小程序环境就走jssdk选照片
          this.localIds.splice(0, this.localIds.length)

          let that = this
          let sourceType = []
          if (this.current.photoOnly) {
            sourceType = ['camera']
          } else {
            sourceType = ['album', 'camera']
          }
          this.$wx.chooseImage({
            count: this.current.uploadOneOnly === 1 ? 1 : 9, // 允许上传的图片个数
            // sizeType: ['original', 'compressed'],
            sizeType: ['compressed'],
            sourceType,
            success: function (res) {
              // 将返回的localIds全局保存
              console.log('chooseImage-suc-', res)
              that.localIds = res.localIds
              if (window.isWexin) {
                that.changeImgToBase64(that.localIds.shift());
              } else if (window.isWxWork) {
                that.uploadImageToWx(that.localIds.shift());
              } else {
                that.$toast.fail('图片上传出错')
              }
            },
            fail: err => {
              console.log('chooseImage-err-', err)
              this.fileInput.click()
            }
          })
        } else {
          // 其他环境就走网页网页选照
          this.fileInput.click()
        }
      },
      // 将图片转换为base64
      changeImgToBase64(localId) {
        let that = this;
        this.$wx.getLocalImgData({
          localId: localId,
          success: function (res) {
            let localData = res.localData;
            let imageBase64 = '';
            if (localData.indexOf('data:image') === 0) {
              //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
              imageBase64 = localData;
            } else {
              //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
              //此时一个正常的base64图片路径就完美生成赋值到img的src中了
              imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
            }

            const appImgFile = base64ToFile(imageBase64)
            const size = showSize(imageBase64)
            that.uploadImage(appImgFile, size);
            // 递归调用
            if (that.localIds.length > 0) {
              that.changeImgToBase64(that.localIds.shift());
            }
          }
        })
      },
      uploadImage(appImgFile, size) {
        let filesInfo = {
          imgName: uuid('IMAGE'),
          imgSize: size,  // KB
          imgUrl: '',
          id: uuid('IMAGE')
        }

        this.showLoading = true
        this.current.root.uploadFileMap[filesInfo.id] = true
        this.$RyFs.upload([appImgFile])
          .then(urlList => {
            filesInfo.imgUrl = urlList[0]
            this.currentRow[this.current.dataId].push(filesInfo)
            this.controlChange()
            this.showLoading = false
            if (this.currentRow[this.current.dataId].length === 1) {
              this.submitData()
            }
            this.settingWaterMark(urlList[0])
          })
          .catch(err => {
            console.error(err)
            this.showLoading = false
          }).finally(() => {
          this.current.root.uploadFileMap[filesInfo.id] = false
        })
      },

      // 删除图片
      removeImage(index) {
        if (this.isReadOnly) return

        this.$dialog.confirm({
          title: '确认信息',
          message: '是否确认删除？',
        })
          .then(() => {
            // on confirm
            this.currentRow[this.current.dataId].splice(index, 1)
            this.controlChange()
          })
          .catch(() => {
            // on cancel
          });

      },

      // 预览图片
      previewImage(idx) {
        if (window.isLark) {
          this.$tt.ready(() => {
            const urls = this.currentRow[this.current.dataId].map(item => item.imgUrl)
            tt.previewImage({
              urls,
              current: urls[idx]
            });

          })
        } else if (window.isDingtalk) {
          this.$dd.ready(() => {
            const urls = this.currentRow[this.current.dataId].map(item => item.imgUrl)
            this.$dd.biz.util.previewImage({
              urls, //图片地址列表
              current: urls[idx], //当前显示的图片链接
              onSuccess : function(result) {
                /**/
              },
              onFail : function(err) {}
            })
          })
        } else {
          ImagePreview({
            images: this.currentRow[this.current.dataId].map(item => item.imgUrl),
            startPosition: idx
          })
        }
      },

      // 安卓用localId传到微信服务器，因为获取不到本地图片的base64
      uploadImageToWx(localId) {
        let that = this;
        this.$wx.uploadImage({
          localId: localId,
          success: function (res) {
            console.log('uploadImageToWx--', res)
            that.uploadToServer(res.serverId);
            // 递归调用
            if (that.localIds.length > 0) {
              that.uploadImageToWx(that.localIds.shift());
            }
          }
        })
      },
      uploadToServer(serverId) {
        let filesInfo = {
          imgName: '',
          imgSize: 0,  // KB
          imgUrl: '',
          id: serverId,
          status: 'uploading',
          uploadTime: new Date().getTime()
        }
        this.currentRow[this.current.dataId].push(filesInfo)

        const formSet = this.current.root
        this.current.root.uploadFileMap[filesInfo.id] = true
        this.$store.dispatch('actionFieldImageUpload', {
          formId: formSet.formId,
          topic: formSet.tmpTopic,
          fieldId: this.current.dataId,
          subTable: 1,
          rowIdx: this.index + 1,
          mediaIdList: [serverId]
        }).catch(console.error)
          .finally(() => {
            this.current.root.uploadFileMap[filesInfo.id] = false
          })
      },

      checkUploadStatus() {
        if (this.currentRow[this.current.dataId]) {
          this.currentRow[this.current.dataId].forEach(item => {
            if (item.status === 'uploading' && item.uploadTime && new Date().getTime() - item.uploadTime > 20000) {
              item.status = 'fail'
              console.log('upload fail-', item.id)
            }
          })
        }
        this.timer = setTimeout(() => {
          this.checkUploadStatus()
        }, 5000)
      },

      receiveUploadImageNewMessage(e) {
        console.log('receiveUploadImageNewMessage', e, this.current.dataId, this.index)
        if (e.detail) {
          const {content} = e.detail

          if (content) {
            const {version, msgType, subTable, rowIdx, resultData = []} = content
            resultData.forEach(item => {
              // 如果是自己的消息，就要触发 插件
              if (this.current.dataId === item.fieldId && rowIdx === this.index + 1) {
                if (this.currentRow[this.current.dataId].length === 1) {
                  this.submitData()
                }
              }
            })
          }
        }
      },

      async settingWaterMark(url) {
        if (!this.current.openWaterMark || this.current.openWaterMark === 'NO') {
          return
        }
        if (!url) {
          return
        }
        const arrTmp = url.split('/')
        if (arrTmp.length <= 1) {
          return
        }
        const fileKey = arrTmp[arrTmp.length - 1]

        let fileType = sessionStorage.getItem(`${this.$store.getters.currentCompanyId}_fileType`)

        if (!fileType) {
          const res = await this.$store.dispatch('actionCompanyFileType').catch(console.error)

          fileType = res.fileType
          sessionStorage.setItem(`${this.$store.getters.currentCompanyId}_fileType`, fileType)
        }

        if (fileType === 'QINIU') {
          const formSet = this.current.root
          this.$store.dispatch('actionFileWaterMarkHandle', {
            appId: formSet.appId,
            formId: formSet.formId,
            fieldId: this.current.dataId,
            data: formSet.getValues(),
            fileKey
          }).catch(console.error)
        }
      }
    }
  }
</script>

<style lang="less">
  .ry-form__image, .ry-form__image-compact {
    .image__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      > .image__list-item {
        width: 60px;
        height: 60px;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 6px;
        position: relative;

        .wait-upload-container {
          width: 60px;
          height: 60px;
          border-radius: 6px;
          border: 1px solid #ebedf0;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        > .image__list-remove {
          position: absolute;
          right: -6px;
          top: -6px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          text-align: center;
          background-color: #333333;
          border: 1px solid #FFFFFF;

          > .van-icon.van-icon-cross {
            color: #FFFFFF;
            line-height: 18px;
          }
        }

      }

      > .image__list-add {
        width: 58px;
        height: 58px;
        line-height: 58px;
        text-align: center;
        border: 1px dashed #ebedf0;
        border-radius: 6px;
        margin-bottom: 8px;

        > i {
          font-size: 40px;
          line-height: 58px;
        }
      }
    }
  }
</style>